module.exports = __webpack_public_path__ + "img/collection-diamondJewelryCollectionRings.3958ced.webp";